export const environment = {
  production: false,
  oidcConfig: {
    client_id: 'AncesTREEWebsite',
    client_secret: '7FA854B7556729CE4E752DB4C82199396A4479A9ACF58A7E2A72D573E3',
    server_host: 'https://dev-auth.ancestree.org',
    redirect_url: window.location.origin + '/callback',
    end_session_redirect_url: window.location.origin + '/logout',
    scopes: 'openid profile ulnWebApi email roles offline_access',
    pkce: true
  },
  webUrl: 'https://dev-app.ancestree.org',
  hostUrl: 'https://dev-app.ancestree.org/',
  attachmentUrl: 'https://dev-ws.ancestree.org/',
  apiBaseUrl: 'https://dev-ws.ancestree.org/api/',
  apiVersion: '1.1',
  cookieDomain: 'ancestree.org',
  privacyPolicyUrl: 'https://s3.us-east-1.amazonaws.com/privacy-policy.ancestree.com/privacy-policy.pdf',
  termsOfServiceUrl: 'https://s3.us-east-1.amazonaws.com/privacy-policy.ancestree.com/terms-of-service.pdf',
  subscriptionTermsUrl: 'https://s3.us-east-1.amazonaws.com/privacy-policy.ancestree.com/subscription_terms_and_benefits.pdf',
  paymentsConfig: {
    squareAPI: {
      url: 'https://sandbox.web.squarecdn.com/v1/square.js', // Square Sandbox js to inject
    },
    appStore: {
      validatorUrl: 'https://dev-ws.ancestree.org/api/AppStore/Validator'
    },
    googlePlay: {
      url: ''
    }
  },
  googleMaps: {
    apiKey: 'AIzaSyCofqPye6qpVj835ax98bxC5_P6l9Jp_Og'
  },
  captchaSiteKey: '6LeHJZkjAAAAAIjxiOZtROA6uxqQLqR9TTCQ5x1c',
  useHash: false,
  scheme: 'org.ancestree.market:/',
  email: 'info@ancestree.org',
  defaultRoute: '/getting-started',
  // Same value as GitHub secret DEV_WAKE_KEY / SAM WakeKey.
  devWakeUrl: 'https://3vgvrhobkequrtet7zqun3reou0dmwwt.lambda-url.us-east-1.on.aws/',
  devWakeKey: 'GZTZy20ueiHh6caxUIsHmi58Ws6fBuPPonRCU2H3'
};
